import type { EditorCommand } from '@atlaskit/editor-common/types';

import type { RemixThinkingPluginMeta } from '../pm-plugins/remix-thinking/remix-thinking-plugin';
import { remixThinkingPluginKey } from '../pm-plugins/remix-thinking/remix-thinking-plugin';

export const clearRemixThinkingDecoration = (): EditorCommand => ({ tr }) => {
	tr.setMeta(remixThinkingPluginKey, {
		clearDecoration: true,
	} satisfies RemixThinkingPluginMeta);

	return tr;
};
